import request from "../utils/request";

export const getDesignerCommissions = '/designer/commission/';

export function modifyDesignerCommission(data: any) {
    return request.request({
        url: '/designer/commission/',
        method: data.id ? 'put' : 'post',
        data: data
    })
}

export function deleteDesignerCommission(id: number) {
    return request.request({
        url: '/designer/commission/',
        method: 'delete',
        params: {commissionId: id}
    })
}

export function importDesignerCommissions(file: File){
    const formData = new FormData()
    formData.append('file', file)
    return request.request({
        url: '/designer/commission/import',
        method: 'post',
        data: formData
    })
}
